export const SET_PARAMETRES = 'paye-bo/parametres/SET_PARAMETRES'

const initialState = {
  parametres: [],
}

export default function parametreModule(state = initialState, action) {
  switch (action.type) {
    case SET_PARAMETRES:
      return { ...state, parametres: action.value }
    default:
      return state
  }
}
